import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const logDebug = (...params: any[]) => {
    if (ga.debug) {
        console.log("Analytics |", ...params); // eslint-disable-line no-console
    }
};

export default logDebug;
